import { CleaveOptions } from "cleave.js/options";
import Cleave from "cleave.js/react";
import React, { useState } from "react";
import { Control, useController } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { classNames } from "../../../utils/classNames";

const NumberField = ({
  name,
  options,
  icon,
  label,
  control,
}: {
  name: string;
  options: CleaveOptions;
  icon: React.ReactNode;
  label: string;
  control: Control;
}) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  const [isFocus, setIsFocus] = useState(false);

  const handleBlur = (e) => {
    const value = e.target.value;
    if (!!!value) {
      setIsFocus(false);
    } else {
      setIsFocus(true);
    }
  };

  return (
    <div className={tw`relative`}>
      <div className={tw`bg-[#EEF5F4] rounded-xl`}>
        <div
          className={tw`w-full my-2 text-left mt-2 flex items-center gap-4 p-4 relative`}
        >
          <div className={tw``}>{icon}</div>
          <div className={tw`flex-1 relative pt-2`}>
            <Cleave
              {...field}
              options={{ ...options }}
              type="text"
              inputMode="numeric"
              onFocus={() => setIsFocus(true)}
              onBlur={handleBlur}
              id={name}
              className={classNames(
                `${tw`w-full bg-transparent outline-none focus:ring-0`}`
              )}
            />
            <label
              htmlFor={name}
              className={classNames(
                isFocus
                  ? tw`-translate-y-[125%] text-normal text-gray-500`
                  : tw`-translate-y-1/2`,
                tw`text-gray-600 cursor-text  absolute top-1/2  left-0 transition-all duration-400 ease-in-out`
              )}
            >
              {label}
            </label>
          </div>
        </div>
      </div>
      {error && (
        <p className={tw`absolute bottom-0 ml-14 text-red-500 text-xs`}>
          {error?.message}
        </p>
      )}
    </div>
  );
};

export default NumberField;
